<template>
    <div class="fieldset">
        <formly-field v-if="!customLayout" :ref="field.key" v-for="field in fields" :form.sync="form"
                      :model.sync="model" :field="field" :key="'formly_'+field.key"></formly-field>
        <slot :keys="keys"></slot>
    </div>
</template>

<script>
    import FormlyForm from 'vue-formly/src/components/FormlyForm'

    export default {
        methods: FormlyForm.methods,
        props: FormlyForm.props,
        computed: FormlyForm.computed,
        created: FormlyForm.created
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// FormlyFormFlex.vue?a05035c4